import get from 'lodash/get';
import AndroidAdapter from './AndroidAdapter';
import IOSAdapter from './IOSAdapter';
import { AppAdapter } from './AppAdapter';
import { StoreType } from '../store';
import allActions from '../../actions/index';
import { getExtras } from '../../reducers/helpers';

const {
  ANSWER_SUCCESS,
  POST_REG_COMPLETE,
  GET_USER_FAILURE,
  REGISTRATION_FAILED_APP_MODE,
  REGISTRATION_REAUTH_APP_MODE,
  INITIALIZE_IN_APP,
  LAUNCH_NATIVE_PLAID_FLOW
} = allActions;

let adapter: AppAdapter | null;
const adapterFactory = (appOs: string): AppAdapter | null => {
  switch (appOs) {
    case 'ios':
      return new IOSAdapter();
    case 'android':
      return new AndroidAdapter();
    default:
      return null;
  }
};

const appBridgeMiddleware =
  (store: StoreType) =>
  (next: typeof Object) =>
  (action: Record<string, unknown>) => {
    const appOs = (get(store.getState(), 'app.appOs', null) ||
      get(action, 'payload.appOs', null)) as string;
    const error = get(action, 'payload.error', undefined);
    const createUserExtras = getExtras(action, 'create_user');
    const { originalQuestionsAndAnswer } = action;

    switch (action.type) {
      case INITIALIZE_IN_APP:
        adapter = adapterFactory(appOs);
        break;
      case POST_REG_COMPLETE:
        if (adapter) {
          adapter.registrationComplete({
            accountType:
              get(store.getState(), 'app.fundingAccounts.accountType') || 'ach',
            initialAmount: get(
              store.getState(),
              'app.answers.setInitialFundingAmount',
              ''
            ),
            needsVerification:
              get(store.getState(), 'app.needsVerification') || false,
            confirmationMessage:
              get(store.getState(), 'app.registeredUser.confirmationMessage') ||
              ''
          });
        }
        break;
      case REGISTRATION_FAILED_APP_MODE:
        adapter = adapter || adapterFactory(appOs);
        if (adapter) {
          adapter.registrationFailed(error as Error);
        }
        break;
      case GET_USER_FAILURE:
      case REGISTRATION_REAUTH_APP_MODE:
        if (adapter) {
          adapter.registrationReAuth();
        }
        break;
      case ANSWER_SUCCESS:
        // Handle account creation
        if (createUserExtras && createUserExtras.user) {
          if (adapter) {
            adapter.setUserInfo({
              email: get(originalQuestionsAndAnswer, 'set_user_email', ''),
              password:
                get(originalQuestionsAndAnswer, 'set_user_password') ||
                get(
                  originalQuestionsAndAnswer,
                  'set_user_password_and_confirm',
                  ''
                ),
              jwt: createUserExtras.token as string
            });
          }
        }
        break;
      case LAUNCH_NATIVE_PLAID_FLOW:
        if (adapter) {
          adapter.launchNativePlaidFlow();
        }
        break;
      default:
        break;
    }
    next(action);
  };

export default appBridgeMiddleware;
